import axios from 'axios';

const API = axios.create({
  baseURL:  process.env.REACT_APP_C2AS_API_URL, //'http://localhost:2500/api', // change to your Node.js server URL
  headers: {
    'Content-Type': 'application/json',
  },
});

export default API;
